/**
 * Reviews carousel for Avis Garantis footer — same Swiper engine as featured collection.
 * Page scroll: 1 / 2 / 3 cards per breakpoint (600 / 990).
 */
if (!customElements.get('avis-garantis-footer-swiper')) {
  class AvisGarantisFooterSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      if (typeof Swiper === 'undefined') return;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.initSwiper());
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    getSlideCount() {
      return this.querySelectorAll('.swiper-slide').length;
    }

    getConfig() {
      const gap = Number(this.dataset.spaceBetween) || 16;

      return {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: gap,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: this.querySelector('.swiper-next'),
          prevEl: this.querySelector('.swiper-prev')
        },
        breakpoints: {
          600: {
            slidesPerView: 2,
            slidesPerGroup: 2
          },
          990: {
            slidesPerView: 3,
            slidesPerGroup: 3
          }
        },
        on: {
          init: () => this.toggleChrome(),
          resize: () => this.toggleChrome(),
          breakpoint: () => this.toggleChrome()
        }
      };
    }

    initSwiper() {
      if (this.swiper) return;

      const slideCount = this.getSlideCount();
      if (slideCount < 2) {
        this.classList.add('is-static');
        return;
      }

      this.classList.remove('is-static');
      this.swiper = new Swiper(this, this.getConfig());
      this.classList.add('is-ready');
      this.toggleChrome();
    }

    toggleChrome() {
      if (!this.swiper) return;

      const slideCount = this.getSlideCount();
      const perView = this.swiper.params.slidesPerView;
      const hide = slideCount <= perView;
      this.classList.toggle('is-static', hide);
    }

    refresh() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      this.classList.remove('is-ready', 'is-static');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.initSwiper());
      });
    }
  }

  customElements.define('avis-garantis-footer-swiper', AvisGarantisFooterSwiper);
}
